import React, { useState, useRef } from "react";
import { Row, Col, Card, CardBody, CardHeader, Form } from "reactstrap";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";

import TableContainerWithLocation from "../Components/TableContainerWithLocation";
import UpdatePermissionModal from "../Components/UpdatePermissionModal";
import { flatPages, getPages } from "@/util/endpoints";

const headerStyle = {
  backgroundColor: "#D15050",
  color: "white",
};

function Permissions(props) {
  const table = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const loadPagination = async (page = 0, size = 10, search, sort) => {
    return {
      data: getPages(page, size),
      total: flatPages.length,
    };
  };

  const refreshTable = () => {
    table.current && table.current.loadAndStoreData();
  };

  const toggleModal = () => {
    isModalOpen && refreshTable();
    setIsModalOpen(!isModalOpen);
  };

  return (
    <>
      <div className="animated fadeIn">
        <Row>
          <Col>
            <Card>
              <CardHeader>Pages</CardHeader>
              <CardBody>
                <Form
                  inline
                  style={{
                    marginBottom: ".5rem",
                    justifyContent: "flex-end",
                  }}></Form>
                <TableContainerWithLocation
                  loadData={loadPagination}
                  wrappedComponentRef={innerComponent => {
                    if (innerComponent) {
                      table.current = innerComponent;
                    }
                  }}>
                  <BootstrapTable
                    headerStyle={headerStyle}
                    version="4"
                    pagination
                    striped
                    hover
                    condensed
                    remote>
                    <TableHeaderColumn
                      dataSort
                      width="200"
                      isKey
                      dataField="name">
                      Page name
                    </TableHeaderColumn>
                  </BootstrapTable>
                </TableContainerWithLocation>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>

      <UpdatePermissionModal
        isOpen={isModalOpen}
        onModalClose={toggleModal}
        addNew
      />
    </>
  );
}

export default Permissions;
